<template>
  <div class="formTitle">
    <span :class="title.length>4?'longTitle':'title'">{{ title }}</span>
    <div class="multipleChoice" v-if="multipleChoice">多选项</div>
  </div>
</template>

<script>
export default {
  name: "formTitle",
  props:{
    title:{
      type:String,
      default:''
    },
    multipleChoice:{
      type:Boolean,
      default:false
    }
  }
}
</script>

<style scoped lang="less">
.formTitle{
  width: fit-content;
  color: rgba(255, 255, 255, 1);
  font-size: 16px;
  font-weight: 600;
  height: 34px;
  line-height: 34px;
  padding: 0;
  margin: 0 0 6px;
  background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
  border-radius: 4px 4px 0 0;
  box-shadow: 0 6px 14px rgba(26, 29, 36, 0.14);
  display: inline-flex;
  align-items: center;
  overflow: hidden;

  .title{
    display: inline-block;
    padding: 0 18px;
  }

  .longTitle{
    display: inline-block;
    padding: 0 18px;
  }

  .multipleChoice{
    display: inline-flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.96);
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    padding: 0 8px;
    margin: 0 12px 0 -6px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.34);
    border-radius: 4px;
    white-space: nowrap;
  }
}

</style>
